import { render, staticRenderFns } from "./dbusiness_first.vue?vue&type=template&id=228aae3d&scoped=true&"
import script from "./dbusiness_first.vue?vue&type=script&lang=js&"
export * from "./dbusiness_first.vue?vue&type=script&lang=js&"
import style0 from "./dbusiness_first.vue?vue&type=style&index=0&id=228aae3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228aae3d",
  null
  
)

export default component.exports